/**
 * image sizes provided by image service
 * PLEASE NOTE: must be sorted by width asc!
 *
 * @see {@link https://wiki.vip.corp.ebay.com/display/EPS/EPS+Image+Sizes} (link deprecated)
 */
export const IMAGES_SIZES = [
    {
        imageId: 14,
        width: 64,
        height: 64
    },
    {
        imageId: 23,
        width: 80,
        height: 80
    },
    {
        imageId: 0,
        width: 96,
        height: 96
    },
    {
        imageId: 56,
        width: 100,
        height: 100
    },
    {
        imageId: 26,
        width: 140,
        height: 140
    },
    {
        imageId: 2,
        width: 200,
        height: 200
    },
    {
        imageId: 62,
        width: 225,
        height: 225
    },
    {
        imageId: 118,
        width: 275,
        height: 275
    },
    {
        imageId: 35,
        width: 300,
        height: 300
    },
    {
        imageId: 1,
        width: 400,
        height: 400
    },
    {
        imageId: 12,
        width: 500,
        height: 500
    },
    {
        imageId: 58,
        width: 640,
        height: 640
    },
    {
        imageId: 59,
        width: 960,
        height: 960
    },
    {
        imageId: 86,
        width: 1024,
        height: 1024
    },
    {
        imageId: 45,
        width: 1200,
        height: 1200
    },
    {
        imageId: 57,
        width: 1600,
        height: 1600
    }
];
export const IMAGE_MAX_SIZE = {
    imageId: 57,
    width: 1600,
    height: 1600
};
/**
 * List of all image sizes provided by image service
 *
 * @returns array of image ids
 */
export const IMAGE_SIZES_AVAILABLE = IMAGES_SIZES.map(({ width }) => width);
